import { Text as ChakraText, TextProps as ChakraTextProps } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

import { getFontFromVariant } from '../../_helpers';

/*
 * Renders a standard text component
 *
 * @prop {ReactNode} children -> The child node that renders inside of the component
 * @prop {String (Enumerable)} fontSize -> Describes the font-size style of the component
 * @prop {String (Enumerable)} fontWeight -> Describes the font-weight style of the component
 */

type FontSizes = 'sm' | 'md' | 'lg' | 'xl';
type FontWeights = 'normal' | 'medium' | 'semibold';

export const fontSizePropTypes: FontSizes[] = ['sm', 'md', 'lg', 'xl'];
export const fontWeightPropTypes: FontWeights[] = ['normal', 'medium', 'semibold'];

const propTypes = {
  children: PropTypes.node.isRequired,
  fontSize: PropTypes.oneOf(fontSizePropTypes),
  fontWeight: PropTypes.oneOf(fontWeightPropTypes)
};

export const defaultProps = {
  fontSize: 'md',
  fontWeight: 'normal'
};

export type TextProps = ChakraTextProps & {
  children: React.ReactNode;
  fontSize?: FontSizes | string;
  fontWeight?: FontWeights | string;
};

export default function Text(props: TextProps): React.ReactElement {
  const { children, fontWeight, ...rest } = props;

  const fontFamily = getFontFromVariant('base', fontWeight!);

  return (
    <ChakraText fontFamily={fontFamily} fontWeight={fontWeight} {...rest}>
      {children}
    </ChakraText>
  );
}

Text.propTypes = propTypes;
Text.defaultProps = defaultProps;
Text.displayName = 'Text';
